import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'IP Blacklist',
    entityNamePlural: 'IP Blacklist',
    entityNameModule: 'settings',
  }), [])
}
